import { render, staticRenderFns } from "./CommentBottomBar.vue?vue&type=template&id=04140dc6&"
import script from "./CommentBottomBar.vue?vue&type=script&lang=js&"
export * from "./CommentBottomBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports